import type { GoogleCoordinates } from '@/user/address-book/types'

export const defaultPosition: GoogleCoordinates = { lat: 41.5325, lng: 12.2933 }

export const globalZoom = 3
export const userZoom = 17

export const minimumPositionDiff = 0.0003

export const userCircleConfig = {
  scale: 11,
  fillColor: '#4285F4',
  fillOpacity: 1,
  strokeColor: 'white',
  strokeWeight: 5,
}
